import { consents } from './consents';
import { numberOfPersons } from './numberOfPersons';
import { travelDestination } from './travelDestination';
import { travelLength } from './travelLength';
import { travelers } from './travelers';
import { obfuscation } from './obfuscation';
import { currentlyInPoland } from './currentlyInPoland';

export const travel = {
  ...consents,
  ...numberOfPersons,
  ...travelDestination,
  ...travelLength,
  ...travelers,
  ...obfuscation,
  ...currentlyInPoland,
};
